import { render, staticRenderFns } from "./UserEditModal.vue?vue&type=template&id=06c8e14a"
import script from "./UserEditModal.vue?vue&type=script&lang=ts"
export * from "./UserEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports